var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.448 6.418-4.863 10.859-.531-2.202c-.9-2.541-3.718-5.302-6.865-6.675l4.454 13.925h5.25l7.805-15.907h-5.25Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07 6.418H.082L0 6.74c6.231 1.322 10.358 4.506 12.054 8.335l-1.737-7.318C10.031 6.74 9.153 6.452 8.07 6.418ZM26.662 22.503h-4.91l3.071-16.21h4.909l-3.07 16.21ZM44.457 6.69c-.969-.328-2.504-.69-4.403-.69-4.848 0-8.262 2.207-8.283 5.362-.04 2.329 2.444 3.622 4.303 4.398 1.899.793 2.544 1.31 2.544 2.018-.019 1.086-1.534 1.586-2.948 1.586-1.96 0-3.01-.258-4.605-.862l-.647-.259-.687 3.639c1.152.447 3.273.845 5.475.862 5.15 0 8.504-2.173 8.544-5.535.02-1.845-1.292-3.26-4.12-4.415-1.718-.741-2.769-1.241-2.769-2 .02-.69.89-1.397 2.827-1.397a9.571 9.571 0 0 1 3.657.621l.444.172.668-3.5Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.244 6.294h3.797L61 22.502h-4.545s-.445-1.862-.586-2.431h-6.302l-1.03 2.431h-5.151L50.677 7.64c.505-1.052 1.395-1.345 2.566-1.345Zm-.303 5.931s-1.555 3.604-1.96 4.535h4.08c-.201-.81-1.13-4.69-1.13-4.69l-.344-1.396c-.144.36-.353.854-.494 1.187-.096.226-.16.378-.152.364Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.9db52e169e30813cae5d0454f22fd34a.svg";
export { ForwardRef as ReactComponent };